(function () {
    'use strict';
    angular.module('modules.chat.velaro').component('monZendesk', {
        transclude: true,
        templateUrl: 'app/modules/chat/zendesk/components/icon/zendesk.html',
        controller: VelaroController,
        controllerAs: 'vm',
    });

    VelaroController.$inject = ['$window'];

    function VelaroController ($window) {
        const vm = this;
        vm.toggle = toggle;

        function toggle () {
            if ($window.zE) {
                $window.zE('messenger', 'show');
                $window.zE('messenger', 'open');
            }
        }
    }
})();
